import { combinedConfig } from "./combinedConfig";

export const brandsArray = [
  {
    name: "Lacoste",
    domains: [
      {
        name: "lacoste.com",
        unit_system: "standard",
        language: "fr",
      },
      {
        name: "shop-fr-staging.lacoste.com",
        unit_system: "standard",
        language: "fr",
      },
      {
        name: "us.lacoste.com",
        unit_system: "imp",
        language: "en",
      },
      {
        name: "gb.lacoste.com",
        unit_system: "imp",
        language: "en",
      },
      {
        name: "br.lacoste.com",
        unit_system: "standard",
        language: "pt",
      },
      {
        name: "de.lacoste.com",
        unit_system: "standard",
        language: "de",
      },
      {
        name: "at.lacoste.com",
        unit_system: "standard",
        language: "de",
      },
      {
        name: "be.lacoste.com",
        unit_system: "standard",
        language: "fr",
      },
      {
        name: "ch.lacoste.com",
        unit_system: "standard",
        language: "en",
      },
      {
        name: "dk.lacoste.com",
        unit_system: "standard",
        language: "en",
      },
      {
        name: "es.lacoste.com",
        unit_system: "standard",
        language: "es",
      },
      {
        name: "ie.lacoste.com",
        unit_system: "standard",
        language: "en",
      },
      {
        name: "it.lacoste.com",
        unit_system: "standard",
        language: "it",
      },
      {
        name: "nl.lacoste.com",
        unit_system: "standard",
        language: "nl",
      },
      {
        name: "pt.lacoste.com",
        unit_system: "standard",
        language: "pt",
      },
      {
        name: "se.lacoste.com",
        unit_system: "standard",
        language: "en",
      },
    ],
    config: combinedConfig.lacoste.config,
  },
  {
    name: "KENZO",
    domains: [
      {
        name: "kenzo.com",
        unit_system: "standard",
      },
      {
        name: "www.kenzo.com",
        unit_system: "standard",
      },
      {
        name: "stg.kenzo.com",
        unit_system: "standard",
      },
      {
        name: "sb03.kenzo.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.kenzo.config,
  },
  {
    name: "Sporty & Rich",
    domains: [
      {
        name: "sportyandrich.com",
        unit_system: "standard",
      },
      {
        name: "sporty-rich.myshopify.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.sportyAndRich.config,
  },
  {
    name: "Place des Tendances",
    domains: [
      {
        name: "placedestendances.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.placeDesTondances.config,
  },
  {
    name: "Le Slip Français",
    domains: [
      {
        name: "www.leslipfrancais.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.leSlipFrancais.config,
  },
  {
    name: "IZAC",
    domains: [
      {
        name: "izac.fr",
        unit_system: "standard",
      },
      {
        name: "izac-paris.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.izac.config,
  },
  {
    name: "JOTT",
    domains: [
      {
        name: "jott.com",
        unit_system: "standard",
      },
      {
        name: "justoverthetop-testing.myshopify.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.jott.config,
  },
  {
    name: "From Future",
    domains: [
      {
        name: "www.fromfuture.com",
        unit_system: "standard",
      },
      {
        name: "fromfuture-int.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.fromFuture.config,
  },
  {
    name: "Circle SportsWear",
    domains: [
      {
        name: "circlesportswear.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.circleSportswear.config,
  },
  {
    name: "Rodier",
    domains: [
      {
        name: "www.rodier.fr",
        unit_system: "standard",
      },
      {
        name: "preprod02-fo-rodier.wshop.cloud",
        unit_system: "standard",
      },
      {
        name: "en.rodier.fr",
        unit_system: "standard",
      },
      {
        name: "www.rodier.be",
        unit_system: "standard",
      },
      {
        name: "www.rodier.at",
        unit_system: "standard",
      },
      {
        name: "www.de-rodier.com",
        unit_system: "standard",
      },
      {
        name: "www.rodier.nl",
        unit_system: "standard",
      },
      {
        name: "www.rodier.pt",
        unit_system: "standard",
      },
      {
        name: "www.rodier.es",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.rodier.config,
  },
  {
    name: "La Canadienne",
    domains: [
      {
        name: "la-canadienne.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.laCanadienne.config,
  },
  {
    name: "Gerard Darel",
    domains: [
      {
        name: "gerarddarel.com",
        unit_system: "standard",
      },
      {
        name: "gerard-darel-development.myshopify.com",
        unit_system: "standard",
      },
      {
        name: "gerard-darel.myshopify.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.gerardDarel.config,
  },
  {
    name: "Ron Dorff",
    domains: [
      {
        name: "rondorff.com",
        unit_system: "standard",
      },
      {
        name: "uk.rondorff.com",
        unit_system: "standard",
      },
      {
        name: "us.rondorff.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.ronDorff.config,
  },
  {
    name: "The Kooples",
    domains: [
      {
        name: "thekooples.com",
        unit_system: "standard",
      },
      {
        name: "dev.thekooples.com",
        unit_system: "standard",
      },
      {
        name: "stg.thekooples.com",
        unit_system: "standard",
      },
      {
        name: "staging.thekooples.com",
        unit_system: "standard",
      },
      {
        name: "www.thekooples.com",
        unit_system: "standard",
      },
      {
        name: "getkleep-marcy-paris.myshopify.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.theKooples.config,
  },
  {
    name: "Chlore",
    domains: [
      {
        name: "www.chlore-swimwear.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.chlore.config,
  },
  {
    name: "Molli",
    domains: [
      {
        name: "www.molli.com",
        unit_system: "standard",
      },
      {
        name: "molli.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.molli.config,
  },
  {
    name: "Place du Jour",
    domains: [
      {
        name: "placedujour.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.placeDuJour.config,
  },
  {
    name: "Gualap",
    domains: [
      {
        name: "gualap.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.gualap.config,
  },
  {
    name: "Vogstore",
    domains: [
      {
        name: "vogstoree.com",
        unit_system: "standard",
      },
      {
        name: "vog-store.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.vogstore.config,
  },
  {
    name: "SRP",
    domains: [
      {
        name: "showroomprive.com",
        unit_system: "standard",
      },
      {
        name: "fr-v4.terone.showroomprive.net",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.srp.config,
  },
  {
    name: "Hartford",
    domains: [
      {
        name: "hartford.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.hartford.config,
  },
  {
    name: "La Petite Etoile",
    domains: [
      {
        name: "www.lapetiteetoile.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.laPetiteEtoile.config,
  },
  {
    name: "Mister K",
    domains: [
      {
        name: "misterk.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.misterK.config,
  },
  {
    name: "Petrone",
    domains: [
      {
        name: "petroneparis.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.petrone.config,
  },
  {
    name: "Zadig & Voltaire",
    domains: [
      {
        name: "zadig-et-voltaire.com",
        unit_system: "standard",
      },
      {
        name: "www.preprod.eu.z-v.cloud",
        unit_system: "standard",
      },
      {
        name: "www.jupiter.eu.z-v.cloud",
        unit_system: "standard",
      },
      {
        name: "www.venus.eu.z-v.cloud",
        unit_system: "standard",
      },
      {
        name: "www.saturne.eu.z-v.cloud",
        unit_system: "standard",
      },
      {
        name: "www.neptune.eu.z-v.cloud",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.zadigVoltaire.config,
  },
  {
    name: "Bensimon",
    domains: [
      {
        name: "bensimon.com",
        unit_system: "standard",
      },
      {
        name: "preprod-fo.bensimon.wshop.cloud",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.bensimon.config,
  },
  {
    name: "Stella & Suzie",
    domains: [
      {
        name: "stellaetsuzie.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.stellaSuzie.config,
  },
  {
    name: "Antonelle",
    domains: [
      {
        name: "www.antonelle.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.antonelle.config,
  },
  {
    name: "Une Jour Ailleurs",
    domains: [
      {
        name: "unjourailleurs.com",
        unit_system: "standard",
      },
      {
        name: "unjourailleurscom.preprod123.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.uneJourAilleurs.config,
  },
  {
    name: "Kookai",
    domains: [
      {
        name: "kookai.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.kookai.config,
  },
  {
    name: "Asphalte",
    domains: [
      {
        name: "asphalte.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.asphalte.config,
  },
  {
    name: "Soeur",
    domains: [
      {
        name: "www.soeur.fr",
        unit_system: "standard",
      },
      {
        name: "www.soeur.uk",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.soeur.config,
  },
  {
    name: "Et Paris",
    domains: [
      {
        name: "etparis.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.etParis.config,
  },
  {
    name: "Faguo",
    domains: [
      {
        name: "faguo-store.com",
        unit_system: "standard",
      },
      {
        name: "faguo-dev01.sidemo.fr",
        unit_system: "standard",
      },
      {
        name: "preprod01.faguo-store.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.faguo.config,
  },
  {
    name: "Project X Paris",
    domains: [
      {
        name: "www.projectxparis.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.projectXParis.config,
  },
  {
    name: "Hast",
    domains: [
      {
        name: "www.hastparis.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.hast.config,
  },
  {
    name: "SAAJ",
    domains: [
      {
        name: "saajparis.fr",
        unit_system: "standard",
      },
      {
        name: "saajparis.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.saaj.config,
  },
  {
    name: "Bonne Gueule",
    domains: [
      {
        name: "bonnegueule.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.bonneGueule.config,
  },
  {
    name: "Devred",
    domains: [
      {
        name: "devred.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.devred.config,
  },
  {
    name: "Theodore",
    domains: [
      {
        name: "theodore.ae",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.theodore.config,
  },
  {
    name: "LTDC",
    domains: [
      {
        name: "letempsdescerises.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.ltdc.config,
  },
  {
    name: "Nina Ricci",
    domains: [
      {
        name: "www.ninaricci.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.ninaRicci.config,
  },
  {
    name: "Maison Kitsuné",
    domains: [
      {
        name: "maisonkitsune.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.maisonKitsune.config,
  },
  {
    name: "Victoria Beckham",
    domains: [
      {
        name: "victoriabeckham.com",
        unit_system: "standard",
        language: "en",
      },
      {
        name: "www.victoriabeckham.com",
        unit_system: "standard",
        language: "en",
      },
      {
        name: "victoria-beckham-uk.myshopify.com",
        unit_system: "imp",
        language: "en",
      },
      {
        name: "international.victoriabeckham.com",
        unit_system: "standard",
        language: "en",
      },
      {
        name: "victoria-beckham-international.myshopify.com",
        unit_system: "standard",
        language: "en",
      },
      {
        name: "us.victoriabeckham.com",
        unit_system: "imp",
        language: "en",
      },
      {
        name: "victoria-beckham-us.myshopify.com",
        unit_system: "imp",
        language: "en",
      },
    ],
    config: combinedConfig.victoriaBeckham.config,
  },
  {
    name: "Rabanne",
    domains: [
      {
        name: "rabanne.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.rabanne.config,
  },
  {
    name: "Weill",
    domains: [
      {
        name: "www.weill.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.weill.config,
  },
  {
    name: "Sud Express",
    domains: [
      {
        name: "sudexpress.com",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.sudExpress.config,
  },
  {
    name: "Loom",
    domains: [
      {
        name: "loom.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.loom.config,
  },
  {
    name: "Alme",
    domains: [
      {
        name: "www.almeparis.com",
        unit_system: "standard",
        language: "fr",
      },
      {
        name: "de.almeparis.com",
        unit_system: "standard",
        language: "de",
      },
      {
        name: "it.almeparis.com",
        unit_system: "standard",
        language: "it",
      },
      {
        name: "gb.almeparis.com",
        unit_system: "imp",
        language: "en",
      },
      {
        name: "es.almeparis.com",
        unit_system: "standard",
        language: "es",
      },
      {
        name: "pt.almeparis.com",
        unit_system: "standard",
        language: "pt",
      },
      {
        name: "nl.almeparis.com",
        unit_system: "standard",
        language: "nl",
      },
    ],
    config: combinedConfig.alme.config,
  },
  {
    name: "Sport 2000",
    domains: [
      {
        name: "www.sport2000.fr",
        unit_system: "standard",
      },
    ],
    config: combinedConfig.sport2000.config,
  },
];
